"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updatePlatformLowBalanceThresholdAction } from "@/server-actions/platform-low-balance-threshold"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { platformLowBalanceThresholdQueryKey } from "@/hooks/queries/platform-low-balance-threshold"
import { useTranslations } from "next-intl"


export function useUpdatePlatformLowBalanceThresholdMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsPlatformLowBalanceThreshold")

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (thresholdMicrousd: number) => {
      const result = await withQueryHandling(updatePlatformLowBalanceThresholdAction({ thresholdMicrousd }), {
        loading: tUi("saving"),
        success: tUi("defaultLowBalanceThresholdSaved"),
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: (saved) => {
      queryClient.setQueryData(platformLowBalanceThresholdQueryKey, saved)
      // The billing snapshot reads the same default.
      void queryClient.invalidateQueries({ queryKey: ["billing"] })
    },
  })
}
